import { toast } from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useAllergyMutations = (patientId) => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  const invalidateAllergies = () => {
    queryClient.invalidateQueries({ queryKey: ["allergies"] });
    queryClient.invalidateQueries({ queryKey: ["seriousAllergies"] });
  };

  const createOrUpdateAllergy = useMutation({
    mutationFn: async (formData) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(`${tenantVal}/allergy`, {
        ...formData,
        patientId: Number(patientId),
      });
      return response.data;
    },
    onSuccess: () => {
      toast.success("Data saved successfully!");
      invalidateAllergies();
    },
  });

  const deleteAllergy = useMutation({
    mutationFn: async (id) => {
      const axiosInstance = createAxiosInstance();
      await axiosInstance.delete(`${tenantVal}/allergy/delete`, {
        data: { id },
      });
    },
    onSuccess: () => {
      toast.success("Allergy has been deleted");
      invalidateAllergies();
    },
  });

  const disableAllergy = useMutation({
    mutationFn: async (id) => {
      const axiosInstance = createAxiosInstance();
      await axiosInstance.post(`${tenantVal}/allergy/disable`, { id, disabled: true });
    },
    onSuccess: () => {
      toast.success("Allergy has been deleted");
      invalidateAllergies();
    },
  });

  return { createOrUpdateAllergy, deleteAllergy, disableAllergy };
};
